// extracted by mini-css-extract-plugin
module.exports = {"root":"_2-T_u","visibleItemsContainer":"CxsuI","allItemsContainer":"i4XNY","item":"_2UHIp","playButtonsDescription":"al0_P","swipeLeftHitArea":"Yl6LQ","swipeRightHitArea":"VpZMp"};